import React, { useEffect, useState } from "react";
import ModalV2 from "../modalV2";
import { useAppSelector } from "../../../hooks";
import { selectDarkmode } from "../../../states/slices/globalReducer";
import { PDF_ICON } from "../../../utils-func/image_exports";
import * as pdfjsLib from "pdfjs-dist";
import "pdfjs-dist/web/pdf_viewer.css";

// pdfjsLib.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.js`;
pdfjsLib.GlobalWorkerOptions.workerSrc = new URL(
  "pdfjs-dist/build/pdf.worker.min.mjs",
  import.meta.url
).toString();
interface DocumentViewProps {
  modalOpen: boolean;
  modalClose: () => void;
  pdfUrl: string;
  pdfName: string;
}
function DocumentView(props: DocumentViewProps) {
  const { modalOpen, modalClose, pdfUrl, pdfName } = props;
  const darkmode = useAppSelector(selectDarkmode);
  const [pdfText, setPdfText] = useState("");
  useEffect(() => {
    const fetchPdfText = async () => {
      try {
        // Load the PDF document
        const pdf = await pdfjsLib.getDocument(pdfUrl).promise;

        let textContent = "";

        // Loop through pages (1-indexed)
        for (let i = 1; i <= pdf.numPages; i++) {
          const page = await pdf.getPage(i); // Correct page index
          const text = await page.getTextContent();

          // Extract text from the page
          const pageText = text.items.map((item: any) => item.str).join(" ");
          textContent += `Page ${i}:\n${pageText.replace(/\n/g, "\n\n")}\n\n`;
        }

        setPdfText(textContent);
      } catch (error) {
        console.error("Error fetching PDF text:", error);
      }
    };

    if (modalOpen) fetchPdfText();
  }, [pdfUrl, modalOpen]);

  const legalPatterns = [
    {
      regex: /^#\s+(.+?)$/gm,
      removeMarker: true,
    },
    {
      regex: /^#{2,}\s+(.+?)$/gm,
      removeMarker: true,
    },
    {
      regex:
        /(?:^|\n)(?:CASE:|IN THE MATTER OF:|SUIT NO:|APPEAL NO:)(.+?)(?:\n|$)/gi,
    },
    {
      regex:
        /(?:^|\n)(?:PRINCIPLE:|LEGAL PRINCIPLE:|RATIO:|RATIO DECIDENDI:)(.+?)(?:\n|$)/gi,
    },
    {
      regex: /\[([^\]]+)\]|\(([^\)]+)\)/g,
    },
    {
      regex:
        /(?:^|\n)(?:CONCLUSION:|JUDGMENT:|HOLDING:|ORDER:|DECISION:)(.+?)(?:\n|$)/gi,
    },
    {
      regex:
        /(?:^|\n)(?:WARNING:|IMPORTANT:|NOTE:|CAVEAT:|DISCLAIMER:)(.+?)(?:\n|$)/gi,
    },
    {
      regex: /(?:^|\n)(?:PROCEDURE:|PROCEEDINGS:|TIMELINE:)(.+?)(?:\n|$)/gi,
    },
    {
      regex: /(?:^|\n)(?:EVIDENCE:|EXHIBITS:|PROOF:)(.+?)(?:\n|$)/gi,
    },
    {
      regex: /(?:^|\n)(?:STATUTE:|SECTION:|LAW:|ACT:)(.+?)(?:\n|$)/gi,
    },
    {
      regex: /\*\*(.+?)\*\*/g,
    },
  ];

  const formatText = (text: string) => {
    if (!text) return null;

    const lines = text.split(/\n/);
    const processedLines = lines.map((line, index) => {
      if (!line.trim()) {
        return <div key={index} className="h-4" />;
      }

      let processedLine = line;

      for (const { regex, removeMarker } of legalPatterns) {
        const matches = Array.from(line.matchAll(new RegExp(regex)));
        if (matches.length > 0) {
          matches.forEach((match) => {
            const content = match[1] || match[0];
            // Remove the markdown markers if removeMarker is true
            processedLine = removeMarker
              ? content
              : processedLine.replace(match[0], `<span>${content}</span>`);
          });
        }
      }

      // Handle markdown-style formatting within text
      processedLine = processedLine
        .replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>")
        .replace(/\*(.*?)\*/g, "<em>$1</em>")
        .replace(/`(.*?)`/g, "<code>$1</code>")
        .replace(/~~(.*?)~~/g, "<del>$1</del>");

      return (
        <div
          key={index}
          className="leading-relaxed py-1"
          dangerouslySetInnerHTML={{ __html: processedLine }}
        />
      );
    });

    return <div className="space-y-1">{processedLines}</div>;
  };

  return (
    <ModalV2
      padding
      isBTnTrue
      isOpen={modalOpen}
      isClose={modalClose}
      maxWidth="max-w-[1003px] lg:w-[1003px]"
      edges="rounded-2xl"
    >
      <div className="flex flex-col gap-y-4 px-7 py-5">
        <span
          className={`text-lg font-semibold border-b text-left pb-3 pl-5 ${
            darkmode ? "text-gray-400 border-gray-700" : "text-[#141718]"
          }`}
        >
          <div className="flex items-center gap-x-3">
            <img src={PDF_ICON} className="w-[40px] h-[40px]" alt="" />
            <span
              className={`font-medium text-sm text-[28.8px] leading-8 text-[#666666]
          }`}
            >
              {/* ADEYEMI FEDERAL UNIVERSITY OF EDUCATION, ONDO (ESTABLISHMENT)
            ACT,2021.html */}
              {pdfName}
            </span>
          </div>
        </span>
        <div
          className={`flex flex-col items-start justify-start px-5 text-[16px] text-start font-medium ${
            darkmode ? "text-gray-400" : "text-[#141718]"
          }`}
        >
          {formatText(pdfText)}
          <br />
        </div>
      </div>
    </ModalV2>
  );
}

export default DocumentView;
